import { AutomationStep, StepError } from '@/types/automationSteps.ts';
import { StepErrorType } from '@/types/stepErrorTypes.ts';
import useIsNewStep from '@/hooks/useIsNewStep.ts';
import { useMemo } from 'react';

function stepErrorToString(error: StepError): string {
  return error.index !== null ? `Data Input ${error.index + 1}: ${error.message}` : error.message;
}

function useStepSpecificError(
  step: AutomationStep,
  errorType: StepErrorType,
  index?: number,
  secondaryIndex?: number,
): string | undefined {
  const isNewStep = useIsNewStep(step?.step_id);

  return useMemo(() => {
    if (isNewStep) {
      return undefined;
    }
    const errors = step.errors
      .filter((e) => e.type === errorType)
      .filter((e) => index === undefined || e.index === index)
      .filter((e) => secondaryIndex === undefined || e.secondary_index === secondaryIndex);
    if (errors.length === 0) {
      return undefined;
    } else if (errors.length === 1) {
      return errors[0].message;
    } else {
      return errors.map((e) => stepErrorToString(e)).join(', ');
    }
  }, [errorType, index, isNewStep, secondaryIndex, step.errors]);
}

export default useStepSpecificError;
